import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"
import { IDependencyMapping } from "./db-dependencies"
import { NetworkConstants } from "./network.constants"

export class Person {

    public static className = "Person"
    public className = "Person"

    public _structureVersion = "1.0"
    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public emailAddresse: string|undefined = undefined
    public vorname: string|undefined = undefined
    public eventLeader: boolean|undefined = undefined
    public groupLeader: boolean|undefined = undefined
    public nachname: string|undefined = undefined
    public telefon: string|undefined = undefined
    public anzeigeName: string|undefined = undefined
    public geschlecht: string|undefined = undefined
    public reportGroup: string|undefined = undefined
    public hundeJagdlichImTreiben:string|undefined = undefined
    public hundeNachsucheGespann: string|undefined = undefined
    public legalPersonalAddress: PersonAddress|undefined = undefined
    public billingAddress: PersonAddress|undefined = undefined
    public creationDate: Date|undefined = undefined
    public updateTimestamp: Date|undefined = undefined
    public anrede: string|undefined = undefined
    public titelAkademisch: string|undefined = undefined
    public titelAndere: string|undefined = undefined
    public kommentar: string|undefined = undefined
    public invitationRef: string|undefined
    public reportGroupId: string|undefined
    public reportGroupTitle: string|undefined
    
    constructor() {}

    getListItemTitle() {
        return this.anzeigeName
    }

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            emailAddresse,
            vorname,
            eventLeader,
            groupLeader,
            nachname,
            telefon,
            anzeigeName,
            geschlecht,
            reportGroup,
            hundeJagdlichImTreiben,
            hundeNachsucheGespann,
            legalPersonalAddress,
            billingAddress,
            creationDate,
            updateTimestamp,
            anrede,
            titelAkademisch,
            titelAndere,
            invitationRef,
            kommentar,
            reportGroupTitle,
            reportGroupId
        } = element
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.emailAddresse = emailAddresse ? emailAddresse : this.emailAddresse
        this.vorname = vorname ? vorname : this.vorname
        this.eventLeader = eventLeader ? eventLeader : this.eventLeader
        this.groupLeader = groupLeader ? groupLeader : this.groupLeader
        this.nachname = nachname ? nachname : this.nachname
        this.telefon = telefon ? telefon : this.telefon
        this.anzeigeName = anzeigeName ? anzeigeName : this.anzeigeName
        if (!this.anzeigeName && (vorname && nachname)) this.anzeigeName = `${vorname} ${nachname}`
        this.geschlecht = geschlecht ? geschlecht : this.geschlecht
        this.reportGroup = reportGroup ? reportGroup : this.reportGroup
        this.hundeJagdlichImTreiben = hundeJagdlichImTreiben ? hundeJagdlichImTreiben : this.hundeJagdlichImTreiben
        this.hundeNachsucheGespann = hundeNachsucheGespann ? hundeNachsucheGespann : this.hundeNachsucheGespann
        this.legalPersonalAddress = legalPersonalAddress ? legalPersonalAddress : this.legalPersonalAddress
        this.billingAddress = billingAddress ? billingAddress : this.billingAddress
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.anrede = anrede ? anrede : this.anrede
        this.titelAkademisch = titelAkademisch ? titelAkademisch: this.titelAkademisch
        this.titelAndere = titelAndere ? titelAndere : this.titelAndere
        this.kommentar = kommentar ? kommentar : this.kommentar
        this.invitationRef = invitationRef ? invitationRef : this.invitationRef
        this.reportGroupId = reportGroupId ? reportGroupId : this.reportGroupId
        this.reportGroupTitle = reportGroupTitle ? reportGroupTitle : this.reportGroupTitle
        
    }
    searchFilter(filter: string): boolean {
        const str = `${this.anzeigeName}${this.emailAddresse}${this.nachname}${this.vorname}`.toLowerCase()
        return str.includes(filter)
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
     replacerFn(key: string) {
        if (key == "className") return false
        else return true
    } 
}

export interface PersonAddress {
    zip: string
    address1: string
    address2?:string
    city: string
    county?: string
    country?: string
}

export const DependencyPersonToEventInvitation: IDependencyMapping =
    {
        collectionName: NetworkConstants.COLLECTION_EVENT_INV,
        mapping: new Map<string, string>([
            ["emailAddresse", "personEmailAddresse"],
            ["nachname", "personNachname"],
            ["vorname", "personVorname"],
            ["anzeigeName", "personAnzeigeName"],
            ["geschlecht", "personGeschlecht"],
            ["anrede", "personAnrede"],
            ["titelAkademisch", "personTitelAkademisch"],
            ["titelAndere", "personTitelAndere"],
            ["telefon", "personTelefon"],
            ["legalPersonalAddress.zip", "personLegalPersonalAddress.zip"],
            ["legalPersonalAddress.address1", "personLegalPersonalAddress.address1"],
            ["legalPersonalAddress.address2", "personLegalPersonalAddress.address2"],
            ["legalPersonalAddress.city", "personLegalPersonalAddress.city"],
            ["legalPersonalAddress.county", "personLegalPersonalAddress.county"],
            ["legalPersonalAddress.country", "personLegalPersonalAddress.country"],
            ["billingAddress.zip", "personBillingAddress.zip"],
            ["billingAddress.address1", "personBillingAddress.address1"],
            ["billingAddress.address2", "personBillingAddress.address2"],
            ["billingAddress.city", "personBillingAddress.city"],
            ["billingAddress.county", "personBillingAddress.county"],
            ["billingAddress.country", "personBillingAddress.country"],
        ]),
        getQuery: (firestore: any, origin: any, now: Date|null): any => {
            return (now != null) ? firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
                .where('personId', '==', origin['identifier'])
                .where('eventDate', '>=', now)
                :
                firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
                .where('personId', '==', origin['identifier'])
        },
        getDoc: (firestore: any, identifier: string) => {
            return null
        }
}